import type { PressableProps } from "react-native"
import React from "react"
import { Pressable, StyleSheet } from "react-native"

import { COLORS, LinkText, testIds, Theme, useIsDarkMode } from "@/theme"
import { renderIconFromIconProp } from "@/theme/icons/renderIconFromIconProp"

import type { IconProp, PressableState, TestIdProps } from "@/theme"

const styles = StyleSheet.create({
  tab: {
    alignItems: "center",
    borderColor: COLORS.$divider.light,
    borderWidth: 1,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "center",
    paddingHorizontal: Theme.SPACING.$2,
    paddingVertical: Theme.SPACING.$1,
  },
  tabHovered: {
    backgroundColor: Theme.COLORS.$blue[200],
  },
  tabHoveredDark: {
    backgroundColor: Theme.COLORS.$gray[700],
  },
  tabPressed: {
    backgroundColor: Theme.COLORS.$yellow[600],
  },
  tabPressedDark: {
    backgroundColor: Theme.COLORS.$green[600],
  },
  tabSelected: {
    backgroundColor: COLORS.$yellow[400],
  },
  tabSelectedDark: {
    backgroundColor: Theme.COLORS.$green[800],
  },
  tabText: {
    marginLeft: Theme.SPACING.$1,
  },
})

export function Tab({
  IconComponent,
  id,
  isSelected,
  style,
  text,
  ...rest
}: Omit<PressableProps, "children" | "id"> &
  TestIdProps & {
    IconComponent?: IconProp
    isSelected: boolean
    text: string
  }) {
  const isDark = useIsDarkMode()

  return (
    <Pressable
      {...testIds(id)}
      accessibilityRole={"tab"}
      style={(state) => {
        const { hovered = false, pressed } = state as PressableState
        if (isDark) {
          return [
            styles.tab,
            hovered && styles.tabHoveredDark,
            pressed && styles.tabPressedDark,
            isSelected && styles.tabSelectedDark,
            typeof style === "function" ? style(state) : style,
          ]
        }
        return [
          styles.tab,
          hovered && styles.tabHovered,
          pressed && styles.tabPressed,
          isSelected && styles.tabSelected,
          typeof style === "function" ? style(state) : style,
        ]
      }}
      {...rest}
    >
      {renderIconFromIconProp(IconComponent, {
        color: isDark ? COLORS.$link.dark : COLORS.$link.light,
        // colorScheme: "secondary",
        size: Theme.SIZES.$3,
      })}

      <LinkText style={styles.tabText}>{text}</LinkText>
    </Pressable>
  )
}
